import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import EntityCrud from 'containers/components/EntityCrud';
import { SALESORDERS } from 'constants/Entities';
import { getActiveCrud } from 'utils/crud';
import { hasExternalCrud } from 'utils/externalCrud';

import SalesOrdersEmbeddedCrud from '../SalesOrdersEmbeddedCrud';
import useSalesOrdersCrud from '../hooks/useSalesOrdersCrud';

const SalesOrdersCrud = memo(() => {
    const props = useSalesOrdersCrud();
    const useEmbeddedCrud = useSelector((state) => {
        const activeCrud = getActiveCrud(state);

        return (
            activeCrud.entity === SALESORDERS.entity &&
            hasExternalCrud(SALESORDERS.entity, state.config?.userData)
        );
    });

    if (useEmbeddedCrud) return <SalesOrdersEmbeddedCrud />;

    return <EntityCrud {...props} />;
});

export default SalesOrdersCrud;
